// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ZbKmOXeNXWHb6k1CLhYnEQ\\=\\={display:flex;height:100%;align-items:center;justify-content:center}", "",{"version":3,"sources":["webpack://./components/layouts/PageSpinner/styles.module.scss"],"names":[],"mappings":"AAAA,4BACE,YAAA,CACA,WAAA,CACA,kBAAA,CACA,sBAAA","sourcesContent":[".spinner {\n  display: flex;\n  height: 100%;\n  align-items: center;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"spinner": "ZbKmOXeNXWHb6k1CLhYnEQ=="
};
export default ___CSS_LOADER_EXPORT___;
